import { motion } from 'framer-motion'
import { Card } from '../components/ui/Card'

const container = { hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.08 } } }
const item = { hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0 } }

export const PrivacyPolicy = () => {
  return (
    <motion.div variants={container} initial="hidden" animate="show" className="space-y-8 max-w-4xl mx-auto">
      <motion.div variants={item} className="text-center">
        <h1 className="text-3xl font-bold text-metallic-900">Privacy Policy</h1>
        <p className="text-metallic-500 mt-2">Last updated: July 2026</p>
      </motion.div>

      <motion.div variants={item}>
        <Card className="space-y-6">
          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">1. Information We Collect</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              We collect: (a) Account information (name, email, company name), (b) Business data you upload or connect (CRM contacts, marketing lists, analytics data), (c) Usage data (pages visited, features used, session duration), (d) Payment information (processed securely by Paystack — we do not store card details), (e) Communication data (messages sent through AI Assistant, support inquiries).
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">2. How We Use Your Information</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              Your information is used to: (a) Provide and maintain the Service, (b) Process AI-powered analytics and generate business insights, (c) Power marketing automation campaigns across your connected channels, (d) Process payments and manage subscriptions, (e) Send service-related communications, (f) Improve the Service through aggregated, anonymized usage analysis, (g) Comply with legal obligations.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">3. AI Data Processing</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              When you use IntelCore's AI features, your data is processed by Groq's AI infrastructure using Llama 3.3 models. This processing is used solely to generate insights, recommendations, and content for your account. Your data is not used to train AI models. AI-processed data is handled in accordance with SOC 2 and GDPR requirements.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">4. Data Sharing</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              We share your data only with: (a) Service providers essential to the Service (Supabase for database, Paystack for payments, Groq for AI processing, Vercel for hosting), (b) Third-party integrations you explicitly connect (WhatsApp Business API, email providers, social media APIs, Google Maps API), (c) Law enforcement when legally required. We never sell your data to advertisers or data brokers.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">5. Data Security</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              We implement industry-standard security: AES-256 encryption at rest, TLS 1.3 in transit, row-level security (RLS) on all database tables, regular security audits, and automated vulnerability scanning. Your data is stored in secure, geographically distributed data centers.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">6. Your Rights (GDPR)</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              You have the right to: (a) Access your personal data, (b) Correct inaccurate data, (c) Delete your account and data, (d) Export your data in standard formats, (e) Object to data processing, (f) Restrict processing, (g) Data portability. Contact us at privacy@intelcorehub.sbs to exercise these rights.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">7. Data Retention</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              Active account data is retained while your account is active. Upon deletion, data is purged within 30 days. Backups are retained for 90 days for disaster recovery. Analytics data is retained in anonymized form for up to 24 months for service improvement.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">8. Cookies & Tracking</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              We use essential cookies for authentication and session management. We do not use third-party advertising cookies. Analytics data is collected in aggregated, anonymized form to improve the Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">9. Children's Privacy</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              The Service is not intended for users under 18. We do not knowingly collect data from children. If we become aware that a child has provided data, we will delete it immediately.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">10. Contact</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              For privacy-related inquiries, contact our Data Protection Officer at privacy@intelcorehub.sbs. We respond to all requests within 30 days.
            </p>
          </section>
        </Card>
      </motion.div>
    </motion.div>
  )
}
